/**
 * @voltxampere/ui — BFG520 RF transistor (Sprint 45-3, placeholder)
 *
 * PLACEHOLDER. Yüksek frekans NPN BJT — DC small-signal Sprint 7
 * stamp ile çalışır, ama RF S-parameters + Cπ + Cµ junction
 * capacitances Sprint 50+ engine extension #4 ile aktif olur.
 *
 * Reference: NXP BFG520 — SOT-143. RF wide-band BJT, V_CEO = 15 V,
 * I_C = 70 mA, β = 100, f_T = 9 GHz, NF = 1.7 dB @ 1 GHz.
 * RF amplifier + LNA (low-noise amp) + mixer + oscillator
 * (FM/UHF receivers, Bluetooth front-end, GPS LNA).
 *
 *   Default mapping → bjt-npn schemaType:
 *     Is = 1e-15        (high-frequency BJT typical)
 *     Bf = 100          (BFG520 datasheet)
 *     Vaf = 30          (lower than audio BJT due to thin base)
 *
 * Engine zero-diff invariant honored — canonical `bjt-npn` engine
 * type via schemaType (Sprint 38 BJT pattern reuse).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { npn } from "../npn.js";
export const rfBfg520 = {
    id: "bfg520",
    nameTr: "BFG520 (RF NPN 9GHz, SOT-143, placeholder)",
    nameEn: "BFG520 (RF NPN 9GHz, SOT-143, placeholder)",
    shortcut: "Q",
    category: "active",
    viewBox: npn.viewBox,
    terminals: npn.terminals,
    defaultLabel: "Q",
    defaultValue: "BFG520",
    schemaType: "bjt-npn",
    defaultParams: { Is: 1e-15, Bf: 100, Vaf: 30 },
    renderSVG: () => npn.renderSVG(),
};
//# sourceMappingURL=rf-bfg520.js.map